export enum AssetType {
    Document = 1,
    Image = 2,
    CheckList = 4,
    CarbonOffsetting = 3,
    Complete = 5,
    Defects = 6
}
